import { Link } from 'react-router-dom';

const serviceLinks = [
  { label: '商業空間策略規劃', href: '/services' },
  { label: '商業空間設計', href: '/services' },
  { label: '裝修工程整合', href: '/services' },
  { label: '品牌升級 / 舊店翻新', href: '/services' },
];

const exploreLinks = [
  { label: '作品案例', href: '/cases' },
  { label: '規劃流程', href: '/process' },
  { label: '常見問題', href: '/faq' },
  { label: '專欄文章', href: '/insights' },
  { label: '關於心旅商研', href: '/about' },
];

export default function Footer() {
  return (
    <footer className="bg-[#1a1a1a] text-white">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/957c6dfa2b6d3bb06c259ccd030b0148.png"
              alt="心旅商研 Logo"
              className="h-10 w-auto object-contain mb-5 brightness-0 invert"
            />
            <p className="text-sm text-white/60 leading-relaxed mb-6">
              商業空間策略規劃 × 空間設計 × 裝修整合落地<br />
              讓每一個商業空間成為品牌最有力的資產
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-[#b8956a] hover:border-[#b8956a] transition-colors cursor-pointer" aria-label="LINE">
                <i className="ri-line-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-[#b8956a] hover:border-[#b8956a] transition-colors cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-[#b8956a] hover:border-[#b8956a] transition-colors cursor-pointer" aria-label="Facebook">
                <i className="ri-facebook-line text-base"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold tracking-widest uppercase text-[#b8956a] mb-5">服務項目</h4>
            <ul className="flex flex-col gap-3">
              {serviceLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Explore */}
          <div>
            <h4 className="text-sm font-semibold tracking-widest uppercase text-[#b8956a] mb-5">探索更多</h4>
            <ul className="flex flex-col gap-3">
              {exploreLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold tracking-widest uppercase text-[#b8956a] mb-5">聯絡資訊</h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-[#b8956a] text-sm"></i>
                </div>
                <span className="text-sm text-white/60">04-2202-3211</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-[#b8956a] text-sm"></i>
                </div>
                <span className="text-sm text-white/60">newplusdesign2017@gmail.com</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-[#b8956a] text-sm"></i>
                </div>
                <span className="text-sm text-white/60">台中市北區中清路一段79號6樓-C</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-chat-1-line text-[#b8956a] text-sm"></i>
                </div>
                <span className="text-sm text-white/60">LINE ID：xinlvdesign</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            © 2024 心旅商研設計有限公司 · 商業空間設計 · 版權所有
          </p>
          <div className="flex items-center gap-4 text-xs text-white/40">
            <a href="#" className="hover:text-white/60 transition-colors cursor-pointer">隱私政策</a>
            <span>|</span>
            <a href="#" className="hover:text-white/60 transition-colors cursor-pointer">服務條款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
